/* unplugin-vue-components disabled */import { render } from "./LiveCard.vue?vue&type=template&id=f3594d98&scoped=true"
import script from "./LiveCard.vue?vue&type=script&lang=js"
export * from "./LiveCard.vue?vue&type=script&lang=js"

import "./LiveCard.vue?vue&type=style&index=0&id=f3594d98&scoped=true&lang=scss"

import exportComponent from "/root/.jenkins/workspace/高保障-门户山农大-前端页面-saas/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f3594d98"]])

export default __exports__